import { render, staticRenderFns } from "./select-ii.vue?vue&type=template&id=4c8d9884&"
import script from "./select-ii.ts?vue&type=script&lang=ts&"
export * from "./select-ii.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports